import { EntityActions } from '../common/base/entity'
// import SimpleCrypto from 'simple-crypto-js'
// import {crypto_secret} from '../../config';

export class AutomationAction extends EntityActions {
	constructor(options) {
		super(options)
		// this.simpleCrypto = new SimpleCrypto(crypto_secret)
	}

	preActionsHooks({ actionName, item }) {
		if (!item || Object.keys(item).length === 0) return
		if (item && actionName == 'editItem' || item && actionName == 'upsertItem') {
			let payload = { ...item }
			if (!payload.status && actionName === 'publishItem') payload.status = 'Published'
			else if (!payload.status) payload.status = 'Draft'
			else if ((payload.status === 'Published' || payload.status === 'UnPublished') && actionName === 'upsert') payload.status = 'Deleted'
			if (payload?.properties?.weeks) {
				payload.properties.days = payload.properties.weeks
			}
			let removeObjectProperties = function (obj, props) {
				for (var i = 0; i < props.length; i++) {
					if (obj.hasOwnProperty(props[i])) {
						delete obj[props[i]]
					}
				}
			}
			let properties = {
				description: item.description,
				days: item.days,
				// cronPattern:item.cronPattern,
				fromState: item.fromState,
				moveToState: payload.moveToState,
			}
			// let lookupProps ={}
			// if(payload.lookupProps && item.itemType && item.itemType !== payload.lookupProps.itemType){
			// 	lookupProps = payload.lookupProps
			// } else {
			// 	if(!payload.lookupProps){
			// 		payload.lookupProps = {}
			// 	}
			// 	payload.lookupProps.itemType= 'default'
			// }
			if (!payload.lookupProps) {
				payload.lookupProps = {}
			}

			let product = localStorage.getItem('product')
			if (payload?.lookupProps && product) {
				payload.lookupProps.usecase = product
			}
			//payload.lookupProps.usecase = localStorage.getItem('product')
			payload.properties = properties
			// console.log(payload, 'payload')
			item = payload
			removeObjectProperties(item, ['description', 'fromState', 'moveToState', 'days', 'weeks'])
			return item
		} else {
			return item
		}
	}

	postActionsHooks({ actionName, item, tenantId }) {
		switch (actionName) {
			case 'getAll':
				let items =
					item &&
					item.map(i => {
						i = Object.assign({}, i, i.properties)
						i.description = i.properties.description
						i.fromState = i.properties.fromState
						i.moveToState = i.properties.moveToState
						return i
					})
				return items
			case 'getOne':
				item = Object.assign({}, item, item.properties)
				return item
			default:
				return item
		}
	}
}
